import React from 'react';
import type { JobType } from '../../utils/types';

interface JobTypeBadgeProps {
  jobType: JobType | null | undefined;
  size?: 'sm' | 'md' | 'lg';
  showLabel?: boolean;
  className?: string;
}

const JOB_TYPE_CONFIG: Record<JobType, {
  label: string;
  shortLabel: string;
  bgColor: string;
  textColor: string;
  borderColor: string;
  description: string;
}> = {
  ga: {
    label: 'Glass Arrival',
    shortLabel: 'GA',
    bgColor: 'bg-blue-50',
    textColor: 'text-blue-700',
    borderColor: 'border-blue-200',
    description: 'Glass arrival job',
  },
  gc: {
    label: 'Glass Cutting',
    shortLabel: 'GC',
    bgColor: 'bg-green-50',
    textColor: 'text-green-700',
    borderColor: 'border-green-200',
    description: 'Glass cutting job',
  },
  gap: {
    label: 'Glass Processing',
    shortLabel: 'GAP',
    bgColor: 'bg-purple-50',
    textColor: 'text-purple-700',
    borderColor: 'border-purple-200',
    description: 'Glass processing job',
  },
};

export const JobTypeBadge: React.FC<JobTypeBadgeProps> = ({ 
  jobType, 
  size = 'md',
  showLabel = false,
  className = ''
}) => {
  if (!jobType) {
    return null;
  }
  
  const config = JOB_TYPE_CONFIG[jobType];
  
  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-1 text-sm',
    lg: 'px-3 py-1.5 text-base',
  };
  
  return (
    <span
      className={`
        inline-flex items-center rounded-full font-medium border
        ${config.bgColor} ${config.textColor} ${config.borderColor}
        ${sizeClasses[size]}
        ${className}
      `.trim().replace(/\s+/g, ' ')}
      title={config.description}
    >
      {showLabel ? config.label : config.shortLabel}
    </span>
  );
};

